import UserService from '../../services/UserService'
import { useQuery } from '@tanstack/react-query'
import { useParams } from 'react-router-dom'
import { DEFAULT_STALE_TIME } from '../../utils/reactQuery'
import { Status } from '../../models/User'

export const useUsers = (
  organization: string,
  tableFilters: Record<string, any>,
  statuses: Status[],
  page?: number,
  size?: number,
) => {
  const { org } = useParams()
  const groupIds = tableFilters['groups']?.map((f: any) => f.id)
  const organizationNodeIds = tableFilters['orgPositions']?.map((f: any) => f.id)
  const applicationCodes = tableFilters['apps']?.map((f: any) => f.id)
  const statusIds =
    tableFilters['status'] && tableFilters['status'].length > 0
      ? tableFilters['status']?.map((f: any) => f.id)
      : statuses?.map((f: any) => f.id)
  const email = tableFilters['email']?.value
  const name = tableFilters['name']?.value

  return useQuery<any>({
    queryKey: [
      'users',
      organization,
      page,
      size,
      groupIds,
      organizationNodeIds,
      applicationCodes,
      statusIds,
      name,
      email,
    ],
    queryFn: () =>
      UserService.listOrganizationUsers(
        organization,
        page,
        size,
        groupIds,
        organizationNodeIds,
        applicationCodes,
        statusIds,
        name,
        email,
      ),
    enabled: !!org,
    staleTime: DEFAULT_STALE_TIME,
  })
}

export const useUsersStatuses = (organization: string) => {
  return useQuery<any>({
    queryKey: ['users-statuses', organization],
    queryFn: () => UserService.listStatuses(organization),
    enabled: !!organization,
    staleTime: DEFAULT_STALE_TIME,
  })
}
